module.exports = __webpack_public_path__ + "img/sala_do_empreendedor_bronze.0808daab.png";